import {AfterViewInit, Component, Injectable, Injector, OnDestroy, OnInit, HostListener} from '@angular/core';
import {AuthService} from './services/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {TaskDescService} from './services/task-desc.service';
import {FabMessageService} from './services/fab-message.service';
import { ApiConnectService } from './services/api-connect.service';
import { UiLocaleService } from './services/ui-locale.service';
import { MobileMenuService } from './services/mobile-menu.service';
import { WorkTimeService } from './services/work-time.service';
import { UserService } from './services/user.service';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import {Location} from '@angular/common';
import {PwaModeService} from './services/pwa-mode.service';
import {PwaInstallService, PWA_INSTALL_ROUTE} from './services/pwa-install.service';

const PASSWORD_RECOVERY_PAGE = '/change-password';
const SIGNIN_PAGE = '/signin';
const URL_SUFFIX = /[?#]/;
const PATH_INDEX = 0;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

@Injectable()
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {

  modalTaskInfo;
  showMobileWorkTime = false;
  private routerSubscription: Subscription;
  private autnService: AuthService;
  private router: Router;
  private location: Location;
  private taskDescService: TaskDescService;
  private uiLocaleService: UiLocaleService;
  private mobileMenuService: MobileMenuService;
  private userService: UserService;
  private workTimeUserId: string;
  public fabService: FabMessageService;
  public apiConnectService: ApiConnectService;
  public workTimeService: WorkTimeService;

  constructor(injector: Injector) {
    injector.get(PwaModeService);
    injector.get(PwaInstallService);
    this.autnService = injector.get(AuthService);
    this.router = injector.get(Router);
    this.location = injector.get(Location, null);
    this.taskDescService = injector.get(TaskDescService);
    this.uiLocaleService = injector.get(UiLocaleService);
    this.fabService = injector.get(FabMessageService);
    this.apiConnectService = injector.get(ApiConnectService);
    this.mobileMenuService = injector.get(MobileMenuService);
    this.workTimeService = injector.get(WorkTimeService);
    this.userService = injector.get(UserService);
  }

  ngOnInit() {
    if (!this.autnService.isAuthenticated() && !this.isPublicEntryPage()) {
      this.router.navigate([SIGNIN_PAGE]);
    }
    this.modalTaskInfo = this.taskDescService.getModalTaskInfo();
    this.uiLocaleService.initialize();
  }

  private isPublicEntryPage(): boolean {
    const path = this.location && this.location.path().split(URL_SUFFIX)[PATH_INDEX];
    return path === PASSWORD_RECOVERY_PAGE || path === PWA_INSTALL_ROUTE;
  }

  ngAfterViewInit() {
    this.routerSubscription = this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(() => this.syncMobileWorkTime());
    this.syncMobileWorkTime();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.workTimeUserId) {
      this.workTimeService.stop();
      this.workTimeUserId = undefined;
      this.showMobileWorkTime = false;
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.syncMobileWorkTime();
  }

  private syncMobileWorkTime() {
    const confirmed = this.autnService.isServerSessionConfirmed();
    this.showMobileWorkTime = confirmed && this.mobileMenuService.isMobile();
    const user = confirmed ? this.userService.getLocal() : undefined;
    const userId = user ? user.id : undefined;
    if (userId === this.workTimeUserId) {
      return;
    }
    if (this.workTimeUserId) {
      this.workTimeService.stop();
    }
    this.workTimeUserId = userId;
    if (userId) {
      this.workTimeService.startOrRefresh();
    }
  }
}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/app.component.ts